export default {
  formNoRibCheck: {
    id: 'buyback_bank_form_no_rib',
    defaultMessage:
      'I do not have this information at the moment. I will add them later.',
  },
}
